import Tooltip from 'primevue/tooltip'

/**
 * `v-tooltip` (legacy `v-b-tooltip`, 57 files): `v-tooltip="text"`, `v-tooltip.left="text"`, `v-tooltip.top="text"`.
 * Registered globally by `installKit()`; PrimeVue's directive, themed by the preset (`tooltip` tokens).
 */
export const vTooltip = Tooltip
